var Shopify = Shopify || {};
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);
  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) { return 0; }
    number = (number/100.0).toFixed(precision);
    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }
  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value).replace(".00", "");
};

const updateShopifyCurrency = (currencyCode) => {
  fetch('/cart/update.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', },
    body: JSON.stringify({ form_type: 'currency', currency: currencyCode }),
  })
  .then(res => { if (res.ok) { location.reload(); } else { console.error('Currency update failed.') } })
  .catch(err => console.error('Error updating currency:', err));
}
const setupCurrency = () => {
  const storageCurrency = localStorage.getItem("currency");
  if( storageCurrency && Shopify.currency.active != storageCurrency) {
    updateShopifyCurrency(storageCurrency);
  }
}
window.addEventListener("load", setupCurrency);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="country_code"]'),
      button: this.querySelector('.currency-switcher > div'),
      panel: this.querySelector('ul.list')
    };

    this.elements.button.addEventListener('click', this.openPanel.bind(this))
    this.elements.panel.addEventListener('click', this.selectCurrency.bind(this));
  }
  openPanel(event) {
    this.elements.panel.style.display = (this.elements.panel.style.display == 'block') ? 'none' : 'block';
    const rect = this.elements.panel.getBoundingClientRect();
    if( rect.right > document.body.clientWidth ) {
      this.elements.panel.style.left = '-' + (( rect.right - document.body.clientWidth ) + 10) + 'px';
    }
  }
  selectCurrency(event) {
    const currencyCode = event.target.dataset.currencyIsoCode;
    const currencySymbol = event.target.dataset.currencySymbol;
    this.elements.button.querySelector('.fflag').setAttribute('class', 'fflag ff-md fflag-'+event.target.dataset.countryIsoCode);
    this.elements.button.querySelector('.currency-iso-code').innerHTML = currencyCode;
    this.elements.button.querySelector('.currency-symbol').innerHTML = currencySymbol;
    this.elements.panel.style.display = 'none';
    this.elements.input.value = event.target.dataset.countryIsoCode;
    const form = this.querySelector('form');
    localStorage.setItem("currency", currencyCode);
    /*
    fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', },
      body: JSON.stringify({ form_type: 'currency', currency: currencyCode }),
    })
    .then(res => { if (res.ok) { 
    } else { console.error('Currency update failed.') } })
    .catch(err => console.error('Error updating currency:', err));
    */
    if (form) form.submit();
  }
}
customElements.define('localization-form', LocalizationForm);